// Vue 入口
//
// 老 main.ts（流式 demo 入口）已搬到 src/streaming/demo-main.ts，仅在历史 commit 7f97862
// 之前的 demo 模式下使用。新版整站走 Vue 路由。

import { createApp } from "vue";
import { createPinia } from "pinia";
import "@vant/touch-emulator"; // 桌面浏览器用鼠标模拟触摸，方便 Vant 组件调试
import "vant/lib/index.css";
import "@/styles/index.css";

import App from "@/App.vue";
import { router } from "@/router";
import { i18n } from "@/i18n";
import { useUserStore } from "@/stores/user";
import { edition } from "@edition";
import {
  getTelegramMiniAppCredential,
  readyTelegramMiniApp,
} from "@/auth/telegram";

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(i18n);

// 异步引导用户态：拿 token 拉用户信息。失败不阻塞 UI 渲染。
const userStore = useUserStore();
const telegramCredential = getTelegramMiniAppCredential();
if (telegramCredential) {
  readyTelegramMiniApp();
  void userStore
    .loginWithThirdParty({
      channelCode: "1",
      appId: edition.oauth.telegramClientId,
      openid: telegramCredential.userId,
      accessToken: telegramCredential.initData,
      d3Type: "telegram_miniapp",
      silent: true,
    })
    .catch(() => {
      // Keep an existing session on transient/backend rollout errors; never create a guest here.
      void userStore.bootstrap(true);
    });
} else {
  userStore.bootstrap(true).catch(() => {
    /* 启动恢复静默失败；bootstrap 会清理失效的持久化会话。 */
  });
}

app.mount("#app");

// Keep the installed PWA current without asking users for a hard refresh.
// HTML/navigation is intentionally not cached by Workbox; this registration
// forces SW checks on load, focus and at a short interval. Live play pages are
// never reloaded in the middle of a cloud session.
if ("serviceWorker" in navigator) {
  let reloading = false;
  const canReload = () =>
    !location.pathname.startsWith("/play/") &&
    location.pathname !== "/streaming-demo.html";
  const reloadForUpdate = () => {
    if (reloading || !canReload()) return;
    reloading = true;
    location.reload();
  };

  navigator.serviceWorker.addEventListener("controllerchange", reloadForUpdate);
  window.addEventListener("load", () => {
    void navigator.serviceWorker
      .register("/sw.js", { scope: "/", updateViaCache: "none" })
      .then((registration) => {
        const check = () => void registration.update().catch(() => undefined);
        check();
        window.setInterval(check, 5 * 60 * 1000);
        window.addEventListener("focus", check);
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") check();
        });
      });
  });
}
